export default "__VITE_ASSET__ByAOtHxS__"